import { createRouter, createWebHistory } from '@ionic/vue-router';
import FinalizeReceipt from "../views/FinalizeReceipt.vue";
import FinalizeShipment from "../views/FinalizeShipment.vue";
import Home from '../views/Home.vue';
import Insert from "../views/Insert.vue";
import InsertMultiple from "../views/InsertMultiple.vue";
import InsertReceipt from "../views/InsertReceipt.vue";
import InsertShipment from "../views/InsertShipment.vue";
import Login from "../views/Login.vue";
import RevisionMultiple from "../views/RevisionMultiple.vue";
import RevisionLocation from "../views/RevisionLocation.vue";
import Search from "../views/Search.vue";

const routes = [
	{
		path: '/',
		redirect: '/login',
	},
	{
		path: "/login",
		name: "LogIn",
		component: Login,
	},
	{
		path: '/home',
		name: 'HomePage',
		component: Home,
	},
	{
		path: '/home/:id',
		name: 'HomeId',
		component: Home,
	},
	{
		path: '/insert',
		name: 'InsertNew',
		component: Insert,
	},
	{
		path: '/insert/receipt',
		name: 'InsertReceipt',
		component: InsertReceipt,
	},
	{
		path: '/insert/receipt/:id',
		name: 'InsertReceiptId',
		component: InsertReceipt,
	},
	{
		path: '/insert/shipment',
		name: 'InsertShipment',
		component: InsertShipment,
	},
	{
		path: '/insert/shipment/:id',
		name: 'InsertShipmentId',
		component: InsertShipment,
	},
	{
		path: "/finalize/receipt",
		name: "FinalizeReceipt",
		component: FinalizeReceipt,
	},
	{
		path: "/finalize/receipt/:id",
		name: "FinalizeReceiptId",
		component: FinalizeReceipt,
	},
	{
		path: "/finalize/shipment",
		name: "FinalizeShipment",
		component: FinalizeShipment,
	},
	{
		path: "/finalize/shipment/:id",
		name: "FinalizeShipmentId",
		component: FinalizeShipment,
	},
	{
		path: '/insert/multiple',
		name: 'InsertMultiple',
		component: InsertMultiple,
	},
	{
		path: '/revision/multiple/:id',
		name: 'RevisionMultipleId',
		component: RevisionMultiple,
	},
	{
		path: '/revision/location/:id',
		name: 'RevisionLocationId',
		component: RevisionLocation,
	},
	{
		path: '/search',
		name: 'SearchElements',
		component: Search,
	},
	{
		path: '/search/:id',
		name: 'SearchProjectId',
		component: Search,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
